import axios from 'axios'

const getDefaultState = () => {
  return {
    hasProforma: true,
    isLocked: false,
    historyVersion: null,
    history: [],

    yardChoices: [],
    lotName: 'N/A',
    lotId: null,
    yardId: null,
    customerReference: null,
    dateReceived: null,
    metalValueDate: null,
    totalUnits: null,
    grossReceived: null,
    scrapWeight: null,
    percentMoisture: null,
    netWetReceived: null,
    netDryWeight: null,
    ptPPM: null,
    ptToz: null,
    ptReturnRate: null,
    pdPPM: null,
    pdToz: null,
    pdReturnRate: null,
    rhPPM: null,
    rhToz: null,
    rhReturnRate: null,
    labFee: null,
    treatmentCharge: null,
    treatmentChargePerLb: 0,
    refiningFee: null,
    refiningChargePt: 0,
    refiningChargePd: 0,
    refiningChargeRh: 0,
    shreddingFee: null,
    shreddingFeePerLb: 0,
    lotCharge: null,
    smallLotFee: null,
    showAssays: false,
    brokerageTerms: {}
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getIsLocked: (state) => state.isLocked,
    getStateSnapshot: (state, getters) => {
      return {
        lot: state.lotId,
        data: {
          yardChoices: state.yardChoices,
          lotName: state.lotName,
          lotId: state.lotId,
          yardId: state.yardId,
          customerReference: state.customerReference,
          dateReceived: state.dateReceived,
          metalValueDate: state.metalValueDate,
          totalUnits: state.totalUnits,
          grossReceived: state.grossReceived,
          scrapWeight: state.scrapWeight,
          percentMoisture: state.percentMoisture,
          netWetReceived: state.netWetReceived,
          netDryWeight: state.netDryWeight,
          ptPPM: state.ptPPM,
          ptToz: state.ptToz,
          ptReturnRate: state.ptReturnRate,
          pdPPM: state.pdPPM,
          pdToz: state.pdToz,
          pdReturnRate: state.pdReturnRate,
          rhPPM: state.rhPPM,
          rhToz: state.rhToz,
          rhReturnRate: state.rhReturnRate,
          labFee: state.labFee,
          treatmentCharge: state.treatmentCharge,
          treatmentChargePerLb: state.treatmentChargePerLb,
          refiningFee: state.refiningFee,
          refiningChargePt: state.refiningChargePt,
          refiningChargePd: state.refiningChargePd,
          refiningChargeRh: state.refiningChargeRh,
          shreddingFee: state.shreddingFee,
          lotCharge: state.lotCharge,
          smallLotFee: state.smallLotFee,
          showAssays: state.showAssays,
          shreddingFeePerLb: state.shreddingFee,

          totalOfCharges: getters.getTotalOfCharges
        }
      }
    },
    getPtTotal: (state) => {
      return (state.ptReturnRate / 100 * state.ptToz).toFixed(3)
    },
    getPdTotal: (state) => {
      return (state.pdReturnRate / 100 * state.pdToz).toFixed(3)
    },
    getRhTotal: (state) => {
      return (state.rhReturnRate / 100 * state.rhToz).toFixed(3)
    },
    getTotalOfCharges: (state, getters) => {
      return (+state.labFee +
        +state.treatmentCharge +
        +state.refiningFee +
        +state.shreddingFee +
        +state.lotCharge +
        +state.smallLotFee).toFixed(2)
    },
    getNetWetReceivedComputed (state) {
      return (+state.grossReceived - +state.scrapWeight).toFixed(2)
    },
    getNetDryWeightComputed (state) {
      const nw = state.netWetReceived
      return (nw - (nw * state.percentMoisture / 100)).toFixed(2)
    },
    getPtPPMComputed (state) {
      return Math.round(state.ptToz / 14.5833 / state.netDryWeight * 1000000)
    },
    getPdPPMComputed (state) {
      return Math.round(state.pdToz / 14.5833 / state.netDryWeight * 1000000)
    },
    getRhPPMComputed (state) {
      return Math.round(state.rhToz / 14.5833 / state.netDryWeight * 1000000)
    }
  },
  mutations: {
    setHasProforma: (state, value) => {
      state.hasProforma = value
    },
    setIsLocked: (state, value) => {
      state.isLocked = value
    },
    setHistoryVersionId (state, value) {
      state.historyVersion = value
    },
    setHistory (state, value) {
      state.history = value
    },
    clearState (state) {
      Object.assign(state, getDefaultState())
    },
    // sets the local variables based on a history entry
    setContextFromHistory (state, value) {
      if ('data_fx' in value) {
        state.historyVersion = value.id
        for (const prop of Object.keys(value.data_fx)) {
          if (prop in state) state[prop] = value.data_fx[prop]
        }
      }
    },
    setYardChoices (state, value) {
      state.yardChoices = value
    },
    setYardId (state, value) {
      state.yardId = value
    },
    setLotName (state, value) {
      state.lotName = value
    },
    setLotId (state, value) {
      state.lotId = value
    },
    setCustomerReference (state, value) {
      state.customerReference = value
    },
    setDateReceived (state, value) {
      state.dateReceived = value
    },
    setMetalValueDate (state, value) {
      state.metalValueDate = value
    },
    setTotalUnits (state, value) {
      state.totalUnits = value
    },
    setGrossReceived (state, value) {
      state.grossReceived = value
    },
    setScrapWeight (state, value) {
      state.scrapWeight = value
    },
    setPercentMoisture (state, value) {
      state.percentMoisture = value
    },
    setNetWetReceived (state, value) {
      state.netWetReceived = value
    },
    setNetDryWeight (state, value) {
      state.netDryWeight = value
    },
    setPtPPM (state, value) {
      state.ptPPM = value
    },
    setPtToz (state, value) {
      state.ptToz = value
    },
    setPtReturnRate (state, value) {
      state.ptReturnRate = value
    },
    setPdPPM (state, value) {
      state.pdPPM = value
    },
    setPdToz (state, value) {
      state.pdToz = value
    },
    setPdReturnRate (state, value) {
      state.pdReturnRate = value
    },
    setRhPPM (state, value) {
      state.rhPPM = value
    },
    setRhToz (state, value) {
      state.rhToz = value
    },
    setRhReturnRate (state, value) {
      state.rhReturnRate = value
    },
    setLabFee (state, value) {
      state.labFee = value
    },
    setTreatmentCharge (state, value) {
      state.treatmentCharge = value
    },
    setTreatmentChargePerLb (state, value) {
      state.treatmentChargePerLb = value
    },
    setRefiningFee (state, value) {
      state.refiningFee = value
    },
    setRefiningChargePt (state, value) {
      state.refiningChargePt = value
    },
    setRefiningChargePd (state, value) {
      state.refiningChargePd = value
    },
    setRefiningChargeRh (state, value) {
      state.refiningChargeRh = value
    },
    setShreddingFee (state, value) {
      state.shreddingFee = value
    },
    setShreddingFeePerLb (state, value) {
      state.shreddingFeePerLb = value
    },
    setLotCharge (state, value) {
      state.lotCharge = value
    },
    setSmallLotFee (state, value) {
      state.smallLotFee = value
    },
    setShowAssays (state, value) {
      state.showAssays = value
    },
    setBrokerageTerms (state, value) {
      state.brokerageTerms = value
    }
  },
  actions: {
    async fetchBrokerageTerms ({ commit, state }) {
      if (!state.yardId) return
      const response = await axios.get(`/api/yards/${state.yardId}/`, { params: { fields: 'brokerageterm' } })
      if (response.data?.brokerageterm) {
        const terms = response.data.brokerageterm
        commit('setBrokerageTerms', terms)
        commit('setShreddingFeePerLb', terms?.shredding_fee_fx)
        commit('setTreatmentChargePerLb', terms?.treatment_charge_fx)
        commit('setRefiningChargePt', terms.refining_charge_pt_fx)
        commit('setRefiningChargePd', terms.refining_charge_pd_fx)
        commit('setRefiningChargeRh', terms.refining_charge_rh_fx)
      } else {
        commit('setSnackbarWarning', 'No Brokerage Terms Available', { root: true })
      }
    },
    async fetchShipmentResults ({ commit, state }) {
      const response = await axios.get('/api/shipment_results/', { params: { lot: state.lotId } })
      commit('setHistory', response.data.results)
    },
    // Gets the current advance calculator context and saves a new entry
    async saveShipmentResult ({ commit, state, getters }) {
      const payload = getters.getStateSnapshot
      const response = await axios.post('/api/shipment_results/', payload)
      if (response.data) {
        commit('setHistory', [response.data, ...state.history])
        commit('setHistoryVersionId', response.data.id)
      }
    },
    async refreshDataFromLotData ({ commit, state, dispatch }) {
      // Fetch lot seed data to populate the report fields
      // LOT ID should already be set
      const response = await axios.get(`/api/lots/${state.lotId}/shipment_result_seed/`)
      if (response.data) {
        const rd = response.data
        if ('hasProforma' in rd) commit('setHasProforma', rd.hasProforma)
        if ('yardChoices' in rd) commit('setYardChoices', rd.yardChoices)
        if ('lotName' in rd) commit('setLotName', rd.lotName)
        if ('lotId' in rd) commit('setLotId', rd.lotId)
        if ('customerReference' in rd) commit('setCustomerReference', rd.customerReference)
        if ('dateReceived' in rd) commit('setDateReceived', rd.dateReceived)
        if ('metalValueDate' in rd) commit('setMetalValueDate', rd.metalValueDate)
        if ('totalUnits' in rd) commit('setTotalUnits', rd.totalUnits)
        if ('grossReceived' in rd) commit('setGrossReceived', rd.grossReceived)
        if ('scrapWeight' in rd) commit('setScrapWeight', rd.scrapWeight)
        if ('percentMoisture' in rd) commit('setPercentMoisture', rd.percentMoisture)
        if ('netWetReceived' in rd) commit('setNetWetReceived', rd.netWetReceived)
        if ('netDryWeight' in rd) commit('setNetDryWeight', rd.netDryWeight)
        if ('ptToz' in rd) commit('setPtToz', rd.ptToz)
        if ('pdToz' in rd) commit('setPdToz', rd.pdToz)
        if ('rhToz' in rd) commit('setRhToz', rd.rhToz)
        if ('labFee' in rd) commit('setLabFee', rd.labFee)
        if ('treatmentCharge' in rd) commit('setTreatmentCharge', rd.treatmentCharge)
        if ('refiningFee' in rd) commit('setRefiningFee', rd.refiningFee)
        if ('shreddingFee' in rd) commit('setShreddingFee', rd.shreddingFee)
        if ('lotCharge' in rd) commit('setLotCharge', rd.lotCharge)
        if ('smallLotFee' in rd) commit('setSmallLotFee', rd.smallLotFee)
        if ('showAssays' in rd) commit('setShowAssays', rd.showAssays)

        commit('setHistoryVersionId', null)
        // These are normally automatically fetched when a yardId is changed in the view - no change no fetch
      }
    }
  }
}
